import { HttpClient } from '#client/http/index'
import { GradesListResponse } from '#client/resources/index'

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data } = await httpClient.get<GradesListResponse>('/user/grades')
  return data
}
